module.exports = __webpack_public_path__ + "img/14.0b8df15a.jpg";